import { useIntl } from 'react-intl'

import {
  formatOccupantsShort,
  getOccupanciesFromReservations,
} from 'lib/offer/occupancyUtils'
import { useOrder } from '../api/order'
import type { AccommodationItem } from 'tripPlanner/types/tripItem'
import { getOrderId } from 'tripPlanner/utils'

export default function useAccommodationItemOccupancyDescription(
  item: AccommodationItem | undefined,
): { occupanciesText?: string, numberOfRoomsText?: string } {
  const intl = useIntl()
  const orderId = item ? getOrderId(item) : undefined

  const { data: order } = useOrder(orderId)

  if (!item) {
    return {}
  }

  if (orderId) {
    if (order?.items.length) {
      const reservations = order.items
        .filter(
          (orderItem) =>
            orderItem.reservation && orderItem.offerId === item.code,
        )
        .map((orderItem) => orderItem.reservation!)
      const occupancies = getOccupanciesFromReservations(...reservations)
      const occupanciesText = formatOccupantsShort(occupancies)
      const numberOfRoomsText =
        reservations.length > 0 ?
            intl.formatMessage({
              id: 'SgIrdbrJgpnoHvePPSqk',
              defaultMessage: '{count, plural, one {# room} other {# rooms}}',
              description: 'Pluralised count of hotel rooms included in the confirmed booking summary',
            }, { count: reservations.length }) :
          undefined
      return { occupanciesText, numberOfRoomsText }
    }
  } else if (item.savedItemData?.occupancies) {
    const occupanciesText = formatOccupantsShort(item.savedItemData.occupancies)
    const numberOfRooms = item.savedItemData.occupancies.length
    const numberOfRoomsText =
      numberOfRooms > 0 ?
          intl.formatMessage({
            id: 'd_m_hyR5fuuPlN1ZIGmb',
            defaultMessage: '{count, plural, one {# room} other {# rooms}}',
            description: 'Number of saved hotel rooms in bookmark on the hotel or room booking page',
          }, { count: numberOfRooms }) :
        undefined
    return { occupanciesText, numberOfRoomsText }
  }

  return {}
}
